// Файл image.js

/**
 * Файл реализует логику модуля «image» в разделе «utils» интерфейса.
 * В нём собраны связанные обработчики и вспомогательные операции для этой части приложения.
 * Код взаимодействует с соседними компонентами и передаёт им подготовленные данные без дублирования общей логики.
 * Такое разделение упрощает сопровождение, проверку поведения и дальнейшее расширение функциональности.
 */

import { API_BASE_URL } from '../../../services/api';

// Файл image.js

const image_url = (file_name) => {
    const normalized_name = String(file_name || '').trim();

    if (!normalized_name) {
        return null;
    }

    if (/^(?:https?:|data:|blob:|\/)/i.test(normalized_name)) {
        return normalized_name;
    }

    return `${API_BASE_URL}/api/static_image/${encodeURIComponent(normalized_name)}`;
};


export const getImageStatic = (item) => {
    if (!item || !item.image) {
        return null;
    }

    const has_extension = String(item.image).includes('.');
    const image_name = has_extension
        ? item.image
        : `${item.image}.png`;

    return image_url(image_name);
};


export const getImage = ({ file_name, version }) => {
    const url = image_url(file_name);

    if (!url || !version) {
        return url;
    }

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${encodeURIComponent(version)}`;
};
